/**
 * @generated SignedSource<<2f4650b3ab172673f5c99f462c65cf77>>
 * @relayHash f0b172d782307a1f28830d1963bd8e5a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ba099f7a8330a410eac268e583530d145e0610acd2b4bd876bcf2ed5880393f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentHeaderUnifiedQuery$variables = {
  contentId: string;
  embeddedContentRender?: string | null;
  includeDevDocsBylineConnection?: boolean | null;
  isMarkdownModeEnabled?: boolean | null;
  limit?: number | null;
  spaceKey?: string | null;
  status?: ReadonlyArray<string | null> | null;
  useNewContentTopper?: boolean | null;
  useObjectHeaderFragment?: boolean | null;
  versionOverride?: number | null;
};
export type ContentHeaderUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors?: ReadonlyArray<{
        readonly history: {
          readonly createdBy: {
            readonly displayName: string | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly contentProperties: {
        readonly latest: {
          readonly generatedBy: string | null;
          readonly isMarkdownMode?: boolean | null;
        } | null;
      } | null;
      readonly contentTypesHeader?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentTypesHeader_content">;
      } | null;
      readonly emojiTitlePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly history: {
        readonly createdBy: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly createdDate: string | null;
        readonly lastOwnedBy: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly ownedBy: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly coverPictureWidth?: string | null;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
        readonly sourceTemplateEntityId: string | null;
      };
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly homepageId: string | null;
        readonly id: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
          readonly type: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly message: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly contentContributors: {
    readonly count: number | null;
    readonly isCurrentUserContributor: boolean | null;
    readonly isOwnerContributor: boolean | null;
    readonly nodes: ReadonlyArray<{
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly header: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
      } | null;
      readonly headings: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null>;
    } | null;
    readonly theme: {
      readonly themeKey: string | null;
    } | null;
  } | null;
};
export type ContentHeaderUnifiedQuery = {
  response: ContentHeaderUnifiedQuery$data;
  variables: ContentHeaderUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "embeddedContentRender"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDevDocsBylineConnection"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isMarkdownModeEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useObjectHeaderFragment"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v10 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v11 = [
  {
    "kind": "Variable",
    "name": "embeddedContentRender",
    "variableName": "embeddedContentRender"
  },
  (v10/*: any*/),
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "type"
},
v14 = {
  "kind": "ScalarField",
  "name": "subType"
},
v15 = {
  "kind": "ScalarField",
  "name": "title"
},
v16 = {
  "kind": "ScalarField",
  "name": "status"
},
v17 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v18 = {
  "kind": "ScalarField",
  "name": "key"
},
v19 = {
  "kind": "ScalarField",
  "name": "value"
},
v20 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v12/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/)
    ]
  }
],
v21 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "devdocsProperties",
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
},
v22 = {
  "kind": "ScalarField",
  "name": "number"
},
v23 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v12/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          (v22/*: any*/)
        ]
      }
    ]
  }
],
v24 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v25 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v27 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v28 = [
  (v13/*: any*/),
  (v17/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/)
],
v29 = {
  "alias": "emojiTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v30 = {
  "condition": "useNewContentTopper",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "pageTitlePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "page-title-property-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v23/*: any*/),
      "storageKey": "properties(key:\"page-title-property-published\")"
    }
  ]
},
v31 = {
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "editor"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": "properties(key:\"editor\")"
},
v32 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "homepageId"
    }
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "message"
},
v34 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v35 = {
  "kind": "ScalarField",
  "name": "when"
},
v36 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v37 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        },
        {
          "condition": "isMarkdownModeEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isMarkdownMode"
            }
          ]
        }
      ]
    }
  ]
},
v38 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceTemplateEntityId"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "coverPictureWidth"
            }
          ]
        }
      ]
    }
  ]
},
v39 = [
  (v10/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  }
],
v40 = {
  "kind": "ScalarField",
  "name": "count"
},
v41 = {
  "kind": "ScalarField",
  "name": "isCurrentUserContributor"
},
v42 = {
  "kind": "ScalarField",
  "name": "isOwnerContributor"
},
v43 = [
  (v18/*: any*/),
  (v19/*: any*/)
],
v44 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "themeKey"
        }
      ]
    },
    {
      "concreteType": "LookAndFeel",
      "kind": "LinkedField",
      "name": "lookAndFeel",
      "plural": false,
      "selections": [
        {
          "concreteType": "MapOfStringToString",
          "kind": "LinkedField",
          "name": "headings",
          "plural": true,
          "selections": (v43/*: any*/)
        },
        {
          "concreteType": "ContentLookAndFeel",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "concreteType": "ContainerLookAndFeel",
              "kind": "LinkedField",
              "name": "header",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "background"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundAttachment"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundBlendMode"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundClip"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundColor"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundImage"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundOrigin"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundPosition"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundRepeat"
                },
                {
                  "kind": "ScalarField",
                  "name": "backgroundSize"
                },
                {
                  "kind": "ScalarField",
                  "name": "borderRadius"
                },
                {
                  "kind": "ScalarField",
                  "name": "padding"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v46 = [
  (v45/*: any*/),
  (v13/*: any*/),
  (v17/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/)
],
v47 = [
  (v45/*: any*/),
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentHeaderUnifiedQuery",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "condition": "useObjectHeaderFragment",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ContentTypesHeader_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentTypesHeader"
                  }
                ]
              },
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "condition": "includeDevDocsBylineConnection",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "ancestors",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v15/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              (v24/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v28/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v28/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v28/*: any*/)
                  }
                ]
              },
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": (v28/*: any*/)
                  },
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v22/*: any*/),
                  (v36/*: any*/)
                ]
              },
              (v37/*: any*/),
              (v38/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v39/*: any*/),
        "concreteType": "ContentContributors",
        "kind": "LinkedField",
        "name": "contentContributors",
        "plural": false,
        "selections": [
          (v40/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v28/*: any*/)
          }
        ]
      },
      (v44/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentHeaderUnifiedQuery",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v24/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v25/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v46/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v46/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v46/*: any*/)
                  }
                ]
              },
              (v29/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": (v46/*: any*/)
                  },
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v22/*: any*/),
                  (v36/*: any*/)
                ]
              },
              (v37/*: any*/),
              (v38/*: any*/),
              {
                "condition": "useObjectHeaderFragment",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "operation"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "targetType"
                      }
                    ]
                  },
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "alias"
                      }
                    ]
                  },
                  {
                    "alias": "smartFolderProperties",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                          "smartFolderProperties"
                        ]
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": (v43/*: any*/)
                      }
                    ],
                    "storageKey": "properties(keys:[\"smartFolderProperties\"])"
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "draftVersion",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v22/*: any*/),
                      (v34/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": (v47/*: any*/)
                      },
                      (v35/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "includeDevDocsBylineConnection",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "ancestors",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v15/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v47/*: any*/)
                          }
                        ]
                      },
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              (v30/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v39/*: any*/),
        "concreteType": "ContentContributors",
        "kind": "LinkedField",
        "name": "contentContributors",
        "plural": false,
        "selections": [
          (v40/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": (v46/*: any*/)
          }
        ]
      },
      (v44/*: any*/)
    ]
  },
  "params": {
    "cacheID": "f0b172d782307a1f28830d1963bd8e5a",
    "id": "6ba099f7a8330a410eac268e583530d145e0610acd2b4bd876bcf2ed5880393f",
    "metadata": {},
    "name": "ContentHeaderUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$isMarkdownModeEnabled:Boolean=false,$includeDevDocsBylineConnection:Boolean=false,$useObjectHeaderFragment:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,...ContentTypesHeader_content@include(if:$useObjectHeaderFragment),type,subType,title,status,ancestors@include(if:$includeDevDocsBylineConnection){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy,isMarkdownMode@include(if:$isMarkdownModeEnabled)}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}"
  }
};
})();

(node as any).hash = "a0102fbc533a258cd91b1391e4402da6";

export default node;
